import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../wayfinder'
import sso77ff5f from './sso'
/**
* @see \App\Http\Controllers\Auth\WorkOSController::sso
* @see app/Http/Controllers/Auth/WorkOSController.php:23
* @route '/sso'
*/
export const sso = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: sso.url(options),
    method: 'get',
})

sso.definition = {
    methods: ["get","head"],
    url: '/sso',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Auth\WorkOSController::sso
* @see app/Http/Controllers/Auth/WorkOSController.php:23
* @route '/sso'
*/
sso.url = (options?: RouteQueryOptions) => {
    return sso.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Auth\WorkOSController::sso
* @see app/Http/Controllers/Auth/WorkOSController.php:23
* @route '/sso'
*/
sso.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: sso.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Auth\WorkOSController::sso
* @see app/Http/Controllers/Auth/WorkOSController.php:23
* @route '/sso'
*/
sso.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: sso.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Auth\AuthenticatedSessionController::cancelTwoFactor
* @see app/Http/Controllers/Auth/AuthenticatedSessionController.php:59
* @route '/login/cancel-two-factor'
*/
export const cancelTwoFactor = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: cancelTwoFactor.url(options),
    method: 'post',
})

cancelTwoFactor.definition = {
    methods: ["post"],
    url: '/login/cancel-two-factor',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Auth\AuthenticatedSessionController::cancelTwoFactor
* @see app/Http/Controllers/Auth/AuthenticatedSessionController.php:59
* @route '/login/cancel-two-factor'
*/
cancelTwoFactor.url = (options?: RouteQueryOptions) => {
    return cancelTwoFactor.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Auth\AuthenticatedSessionController::cancelTwoFactor
* @see app/Http/Controllers/Auth/AuthenticatedSessionController.php:59
* @route '/login/cancel-two-factor'
*/
cancelTwoFactor.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: cancelTwoFactor.url(options),
    method: 'post',
})

const login = {
    sso: Object.assign(sso, sso77ff5f),
    cancelTwoFactor: Object.assign(cancelTwoFactor, cancelTwoFactor),
}

export default login